import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-delete-account-verify',
  templateUrl: './delete-account-verify.component.html',
  styleUrls: ['./delete-account-verify.component.css']
})
export class DeleteAccountVerifyComponent implements OnInit {
  api_success: string;
  api_error: any;
  delcount: any;
  accountType: any;
  btndisabled = true;
  branchview;
  claimview;
  loading: boolean;

  constructor(private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: number, private accountService: AccountService) { }

  ngOnInit() {
    this.delcount = this.data['count'];
    this.accountType = this.data['type'];
    // console.log(this.accountType);
    if (this.data['claimedStatus'] === 'Unclaimed') {
      this.claimview = true;
    }
    else{
      this.branchview = true;
    }
    if (this.delcount > 0) {
      this.btndisabled = false;
    }
  }

  onDeleteConfirm() {
    this.btndisabled = true;
    this.loading = true;
    if (this.accountType === 'Account') {
      if (this.data['claimedStatus'] && this.data['claimedStatus'] === 'Unclaimed') {
       this.accountService.deleteUnclaimedAccounts(this.data['filter'])
       .subscribe(res => {
        this.loading = false;
        this.api_success = 'Account deletion in progress you will receive mail after deletion';
        this.btndisabled =  false;
        setTimeout(() => {
          this.dialogRef.close('reloadlist');
        }, 2000);
       },
       (error) => {
        this.loading = false;
        this.api_error = error.error;
        this.btndisabled = false;
      }
       );
      } else {
    this.accountService.deleteAccounts(this.data['filter'])
      .subscribe(
        data => {
          this.loading = false;
          this.api_success = 'Account deletion in progress you will receive mail after deletion';
          this.btndisabled =  false;
          setTimeout(() => {
            this.dialogRef.close('reloadlist');
          }, 2000);
        },
        (error) => {
          this.loading = false;
          this.api_error = error.error;
          this.btndisabled = false;
        }
      );
  }
} else {
  this.accountService.deleteBranch(this.data['filter'])
  .subscribe(
    data => {
      this.loading = false;
      this.api_success = 'Branch/Branch sp deletion in progress you will receive mail after deletion';
      this.btndisabled = false;
      setTimeout(() => {
        this.dialogRef.close('reloadlist');
      }, 2000);
    },
    (error) => {
      this.api_error = error.error;
      this.btndisabled = false;
      this.loading = false;
    }
  );

}

}

}
